// ─────────────────────────────────────────────────────────────────────────────
// licenseText.js — LICENSE.txt embedded as a string constant
// Source of truth is /LICENSE.txt at the repository root.
// Keep in sync manually when LICENSE.txt is updated.
// ─────────────────────────────────────────────────────────────────────────────

const LICENSE_TEXT = `================================================================================
PSP/CRE TOOL — PROPRIETARY SOFTWARE LICENSE
================================================================================

Software:       PSP/CRE Tool (Pierderi Sanitare Probabile / Casualty Rate Estimator)
Version:        3.0
Author:         Tatar Radu, MD
Copyright:      © 2024–2026 Tatar Radu, MD. All rights reserved.
Contact:        [author contact — to be completed]

--------------------------------------------------------------------------------
PREAMBLE
--------------------------------------------------------------------------------

This software was conceived, designed, and developed solely by Tatar Radu, MD,
as an original intellectual work combining military medical doctrine, NATO
standards, operational research methodology, and software engineering.

The PSP/CRE Tool is proprietary software. It is NOT open-source, NOT freeware,
and NOT public domain. All intellectual property rights — including but not
limited to the architecture, algorithms, constants, calculation engine, user
interface design, doctrinal interpretations, and educational content — are
exclusively owned by the author.

This license governs all use of the software and its associated files,
documentation, and data.

--------------------------------------------------------------------------------
ARTICLE 1 — PERMITTED USES
--------------------------------------------------------------------------------

The following uses are permitted WITHOUT requiring separate written approval,
provided they are strictly non-commercial and non-operational:

1.1  EDUCATIONAL USE — Use by students enrolled in military medical education
     programs under the direct supervision of the author, or in institutions
     where the author has granted explicit educational permission.

1.2  DEMONSTRATION USE — Demonstration of the tool's capabilities to
     prospective institutional partners or military medical authorities,
     provided no permanent deployment or integration occurs.

1.3  PERSONAL REVIEW — Review and evaluation of the software by the author
     and authorized development collaborators.

All other uses require explicit written approval under Article 2.

--------------------------------------------------------------------------------
ARTICLE 2 — USES REQUIRING EXPLICIT WRITTEN APPROVAL
--------------------------------------------------------------------------------

The following uses are PROHIBITED without prior explicit written approval
from the author:

2.1  INSTITUTIONAL DEPLOYMENT — Installation or use within any military,
     governmental, academic, or commercial institution.

2.2  OPERATIONAL USE — Use in any real-world military planning, operational
     decision-making, or mission execution context, regardless of the level
     of command or type of operation.

2.3  REDISTRIBUTION — Distribution, sharing, transfer, or publication of the
     software or any portion thereof, in source or compiled form, by any
     means including electronic distribution, cloud hosting, or physical media.

2.4  MODIFICATION AND DERIVATIVE WORKS — Modification, adaptation, translation,
     reverse engineering, decompilation, or creation of derivative works based
     on this software or any of its components.

2.5  COMMERCIAL USE — Any use for commercial purposes, including integration
     into commercial products or services, or use by for-profit entities.

2.6  INTEGRATION — Integration with other software systems, databases,
     decision support tools, or command and control systems.

2.7  TRAINING PROGRAMS — Use in formal military or civilian training curricula
     not directly supervised by the author.

To request written approval, contact the author at [author contact].
Approval requests must describe the intended use, institution, duration,
and scope of deployment.

--------------------------------------------------------------------------------
ARTICLE 3 — OPERATIONAL USE RESTRICTIONS
--------------------------------------------------------------------------------

3.1  This software has NOT been validated for operational military use.
     Casualty estimates produced by this tool are based on historical data,
     doctrinal models, and statistical approximations. They do not constitute
     authoritative military intelligence assessments.

3.2  Any operational use — even with written approval — requires independent
     validation and verification by qualified military medical authorities
     prior to use in any planning or decision-making process.

3.3  The author expressly disclaims responsibility for any outcomes resulting
     from operational use of this software without proper validation.

--------------------------------------------------------------------------------
ARTICLE 4 — ATTRIBUTION REQUIREMENTS
--------------------------------------------------------------------------------

4.1  Any permitted use of this software must preserve all copyright notices,
     author attributions, version information, and this license file in their
     original form.

4.2  Any publication, presentation, or report that references results produced
     by this software must cite the author as: Tatar Radu, MD, "PSP/CRE Tool
     v3.0", [year].

4.3  Removal, modification, or concealment of authorship information from the
     software interface or source files is prohibited.

--------------------------------------------------------------------------------
ARTICLE 5 — WARRANTY DISCLAIMER
--------------------------------------------------------------------------------

THIS SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS
FOR A PARTICULAR PURPOSE, ACCURACY OF CALCULATIONS, DOCTRINAL COMPLIANCE,
OR NON-INFRINGEMENT.

THE AUTHOR MAKES NO REPRESENTATION THAT THE CASUALTY ESTIMATES, MEDICAL
PLANNING OUTPUTS, OR ANY OTHER RESULTS PRODUCED BY THIS SOFTWARE ARE ACCURATE,
COMPLETE, OR SUITABLE FOR ANY PARTICULAR PURPOSE.

IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM THE USE OR INABILITY
TO USE THIS SOFTWARE, INCLUDING BUT NOT LIMITED TO LOSSES ARISING FROM
OPERATIONAL DECISIONS MADE ON THE BASIS OF SOFTWARE OUTPUTS.

--------------------------------------------------------------------------------
ARTICLE 6 — GOVERNING LAW AND JURISDICTION
--------------------------------------------------------------------------------

6.1  This license shall be governed by and construed in accordance with the
     laws of Romania, without regard to conflict of law provisions.

6.2  Any dispute arising from this license or the use of this software shall
     be subject to the exclusive jurisdiction of the competent courts of
     Romania.

--------------------------------------------------------------------------------
ARTICLE 7 — TERMINATION
--------------------------------------------------------------------------------

7.1  Any permitted use under Article 1 terminates automatically upon any
     breach of the terms of this license.

7.2  Any written approval granted under Article 2 may be revoked by the author
     with 30 days written notice, or immediately in the case of material breach.

7.3  Upon termination, all copies of the software in the possession of the
     licensee must be deleted or returned to the author.

--------------------------------------------------------------------------------
ARTICLE 8 — ENTIRE AGREEMENT
--------------------------------------------------------------------------------

This license constitutes the entire agreement between the author and any user
of this software regarding its use. No prior agreements, representations,
or understandings — oral or written — supersede this license.

The author reserves the right to update the terms of this license for future
versions. The terms applicable to any given version of the software are those
in force at the time of that version's release.

--------------------------------------------------------------------------------

© 2024–2026 Tatar Radu, MD. All rights reserved.
Unauthorized use, reproduction, or distribution of this software is strictly
prohibited and may result in civil and criminal liability under applicable law.

================================================================================`;

export default LICENSE_TEXT;
